{
  "allApps": "所有應用程式",
  "back": "返回首頁",
  "myApps": "我的應用程式",
  "viewMoreApps": "檢視更多應用程式"
}
